export default __webpack_public_path__ + "static/media/web.6ed42b43.svg";